import React, {useEffect, useState} from "react"
import {TaskControls} from "../components/task_buttons/TaskControls"
import ExportProductsApi from "../api/ExportProductsApi"
import {appPages} from "../App"
import {Link} from "react-router-dom"
import {CommandData} from "../utils/RequestsHelper"


export const ExportPage = () => {
    const [showCommand, setShowCommand] = useState(false)

    const [catCount, setCatCount] = useState(0)
    const [prodCount, setProdCount] = useState(0)
    const [commandData, setCommandData] = useState<CommandData | undefined>()

    useEffect(() => {
        ExportProductsApi.exportData().then((result) => {
            setCatCount(result.data.data.categories_count)
            setProdCount(result.data.data.products_count)
        })
        ExportProductsApi.data().then((response) => {
            setCommandData(response.data.data.exportProducts)
            setShowCommand(response.data.data.showCommand)
        })
    }, [])

    return <React.Fragment>
        <h1>5. Экспорт товаров</h1>
        <p className={"gray"}>
            К отправке в Ozon подготовлено {prodCount} товаров из {catCount} категорий
        </p>
        <TaskControls
            command={commandData}
            start={ExportProductsApi.start}
            afterButton={() => <Link to={appPages.offerAttributes}> вернуться назад</Link>}
            hideInput={!showCommand}
            buttonText={() => <>Экспортировать товары <i className="fa fa-arrow-right" aria-hidden="true"/></>}
        />

    </React.Fragment>

}